import { Badge } from "@/components/ui/badge";
import { StaticCartItem as StaticCartItemType } from "@/contexts/StaticCartContext";

interface StaticCartItemProps {
  item: StaticCartItemType;
}

export function StaticCartItem({ item }: StaticCartItemProps) {
  return (
    <div className="flex gap-4 p-4 border-b border-border">
      <div className="w-20 h-20 rounded-lg overflow-hidden bg-muted flex-shrink-0">
        <img 
          src={item.imageUrl} 
          alt={item.title}
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="flex-1">
        <div className="flex justify-between items-start">
          <div>
            <h3 className="font-medium text-foreground line-clamp-2">
              {item.title}
            </h3>
            <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
              {item.description}
            </p>
          </div>
          
          <div className="text-right ml-4">
            {item.isBonus ? (
              <div className="space-y-1">
                <Badge variant="secondary" className="bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100">
                  BÔNUS GRÁTIS
                </Badge>
                <div className="text-sm">
                  <span className="line-through text-muted-foreground">{item.originalPrice}</span>
                </div>
                <div className="font-semibold text-green-600 dark:text-green-400">
                  GRÁTIS
                </div>
              </div>
            ) : (
              <div className="font-semibold text-foreground">
                {item.finalPrice}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}